import { Tooltip, useTheme } from '@mui/material';
import { CollectionFlag } from '../../../components/icons/collection-flag';
import { cn } from '../../../components/utils';

export function ErrorContentWrapper({
  className,
  useTooltip,
  disabled,
  errors,
  showCollectionFlag,
  displayValue,
}: {
  className: string;
  useTooltip: boolean;
  disabled: boolean;
  errors: string[];
  showCollectionFlag: boolean;
  displayValue?: string;
}) {
  const {
    palette: { greyscaleLight },
  } = useTheme();

  const innerContent = (
    <div
      className={cn(className, errors.length > 0 && 'bg-red-100')}
      style={disabled ? { backgroundColor: greyscaleLight[50] } : {}}
    >
      <span className="text-red-500 text-sm">{displayValue}</span>
      {showCollectionFlag && <CollectionFlag />}
    </div>
  );

  if (useTooltip) {
    return (
      <Tooltip arrow title={errors.join(', ')}>
        {innerContent}
      </Tooltip>
    );
  } else {
    return innerContent;
  }
}
